/** As 20 cores fixas dos cadastros (doc 01): salmão, rosas, vermelho, marrom, laranjas… */
export const COLOR_PALETTE = [
  '#F87171',
  '#F472B6',
  '#EC4899',
  '#DC2626',
  '#92400E',
  '#F97316',
  '#F59E0B',
  '#84CC16',
  '#22C55E',
  '#15803D',
  '#14B8A6',
  '#0EA5E9',
  '#3B82F6',
  '#1D4ED8',
  '#A78BFA',
  '#C084FC',
  '#7C3AED',
  '#64748B',
  '#334155',
  '#FFFFFF',
];

/** Paleta menor, a dos grupos de campos adicionais. */
export const GROUP_PALETTE = [
  '#3B82F6',
  '#14B8A6',
  '#22C55E',
  '#84CC16',
  '#F59E0B',
  '#F97316',
  '#EF4444',
  '#EC4899',
  '#8B5CF6',
  '#64748B',
];
